/**
 * SkipLink — Visually-hidden skip-to-content link for keyboard/screen reader users.
 * Becomes visible on focus. Targets #main-content on each page.
 * Requirements: 3.1, 4.2
 */
export const SkipLink = () => (
  <a
    href="#main-content"
    className="skip-link"
    aria-label="Skip to main content"
  >
    Skip to main content
  </a>
);
